<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { mapState } from "vuex";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      products: null,
      login: false,
    };
  },
  methods: {
    getProducts() {
      api
      .get("saas/products")
      .then((response) => {
        if (response.data.status == "success") {
          this.products = response.data.list;
        } else {
          this.products = [];
        }
      });
    },
    getLogin(id) {
      this.login = true;

      api
      .post("saas/products/login", { id: id })
      .then((response) => {
        if (response.data.status == "success") {
          this.login = false;
          window.open(response.data.url, '_blank');
        } else {
          this.login = false;
          this.$toast.error(response.data.message);
        }
      });
    },
  },
  mounted() {
    this.getProducts();
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Meus Produtos</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!products" class="text-center">
      <b-spinner class="align-middle" variant="default" role="status"></b-spinner>
    </div>
    <div v-else-if="products && products.length > 0">
      <div class="row">
        <div class="col-lg-4" v-for="(row, index) in products" :key="index">
          <div class="card">
            <div class="card-body text-center">
              <p class="mb-0 font-size-12 text-uppercase text-muted">{{ row.code }}</p>
              <h4 class="mb-3">{{ row.type }}</h4>
              <div v-html="row.description"></div>
              <a class="my-2 btn btn-default btn-block btn-lg text-uppercase" :class="{ 'disabled': row.status == 'expired', 'disabled': row.status == 'inactive' }" target="_blank" :href="row.url" v-on:click="getLogin(row.id)" :disabled="login">
                Acessar
                <svg class="align-bottom" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
                  <path d="m13 3 3.293 3.293-7 7 1.414 1.414 7-7L21 11V3z"></path>
                  <path d="M19 19H5V5h7l-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5l-2-2v7z"></path>
                </svg>
                <b-spinner v-if="login" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
              </a>
              <p class="mb-0 font-size-16 text-uppercase text-muted" v-if="row.status == 'active'">Ativo até {{ row.date_expiration }}</p>
              <p class="mb-0 font-size-16 text-uppercase text-muted" v-else-if="row.status == 'expired'">Expirado em {{ row.date_expiration }}</p>
              <p class="mb-0 font-size-16 text-uppercase text-muted" v-else>Aguardando ativação</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      Nenhum produto disponível no momento.
    </div>
  </Layout>
</template>